"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Dot = _ref => {
  let {
    status,
    width = 8,
    className,
    pulse = true,
    id,
    glow = true,
    style
  } = _ref;
  const getDotColor = () => {
    if (status === 'up') return '#34D399';
    // if (status === 'up') return 'linear-gradient(-30deg, hsl(158deg 87% 12%) 0%, hsl(159deg 94% 49%) 100%);';
    // if (status === 'up') return 'linear-gradient(180deg,rgba(51,195,74,.02),rgba(25,187,36,.72)),radial-gradient(circle closest-side at 50% 50%,rgba(51,195,74,.1) 68%,rgba(15,137,34,.5));';
    if (status === 'incident') return '#FFAF36';
    if (status === 'outage') return '#E95858';
    if (status === 'maintenance') return '#2388ff';
    if (status === 'paused') return '#9a9fa6';
  };
  {/* <div className="br-10px absolute mr-075em" style={{background:'linear-gradient(-30deg, hsl(158deg 67% 40%) 0%, hsl(159deg 100% 82%) 100%);', width:'10px', height:'10px', opacity: '0.85'}} /> */}
  {/* <div className="absolute pointer-events-none pulse" style={{
    background: `radial-gradient(circle, ${getDotColor()}, ${getDotColor()}00, ${getDotColor()}00)`,
    width: '144px',
    height: '144px',
    opacity: 0.15,
    top: -67,
    left: -67,
   }}></div> */}
  return /*#__PURE__*/_react.default.createElement("div", {
    id: id,
    className: "hpd-dot".concat(className ? ' ' + className : ''),
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "br-10px relative",
    style: {
      width: width + 'px',
      height: width + 'px',
      background: getDotColor(),
      opacity: '1'
    }
  }, glow && /*#__PURE__*/_react.default.createElement("div", {
    className: "br-10px absolute",
    style: {
      width: width + 'px',
      height: width + 'px',
      background: getDotColor(),
      transform: 'scale(2)',
      opacity: '0.2'
    }
  }), status !== 'paused' && pulse && /*#__PURE__*/_react.default.createElement("div", {
    className: "br-20px absolute pulse-".concat(status),
    style: {
      width: width + 'px',
      height: width + 'px',
      background: getDotColor(),
      transform: 'scale(2)',
      opacity: '1'
    }
  })));
};
var _default = exports.default = Dot;